import React from 'react';
import {Grid} from "@material-ui/core";
import {
   Footer, TopNavBar
} from '../../components'
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import Seo from "../../components/Seo";

const data1 = [2, 2, 2,]

function Index(props) {
  // const [order] = useState(props.isOrder || true)
  const onSearchClick = (item,category) => {
     props.history.push({
      pathname: '/result',
      state: {search: item, category: category}
    })
  }
  return (
    <>
      <Seo
        title="Support"
        description="Get help with the AgriLive verified digital agriculture marketplace."
        path="/support"
      />
      <TopNavBar onClick={onSearchClick}/>
      <Grid container justify='center' className='support-ticket-container mt-60'>
        <div className='p-main full-width' style={{minHeight: 520}}>
          <h1 className='font-30'>{'Support Ticket'}</h1>
          {data1.map(() => {
            return (
              <Card style={{boxShadow: 'none', border: 'none'}}>
                {/*className={classes.root}>*/}
                <CardActionArea className='display-flex align-items-center flex-column'>
                  <div className=' pl-10 display-flex align-items-center align-self-start mt-20' >
                    <p className='user-custom-icon-for-ticket'>.</p>
                    <div className='pl-20' style={{minWidth:'7%',maxWidth:'10%'}}>
                      <p className='m-0 text-bold black-color'style={{wordWrap:'anywhere'}}>Jason Huanggsgsfgsfggsdfgfg</p>
                      <p className='m-0 font-14 in-active-color mt-5'>customer</p>
                    </div>
                    <Typography variant="body2" color="textSecondary" component="p"
                                className=' ml-20  pt-10  '>
                      Arrived as expected, well packed properly protected, looks good construction and finish. Arrived
                      quickly and without any extra fee.
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                      labore et dolore magna aliqua. Ut enim ad minim veniam.
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                      labore et dolore magna aliqua. Ut enim ad minim veniam
                    </Typography>
                  </div>
                </CardActionArea>
              </Card>
            )
          })}
        </div>
        <div className='display-flex  flex-column align-items-center checkout-container mt-30'>
          <button className=' add-cart-btn-small pt-15 pb-15'> SEND</button>
        </div>
      </Grid>
      <Footer/>
    </>
  );
}

export default Index;
